import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { Customer } from "@acto/taskpane/core/domain";
import { mapClientToCustomer } from "./mapClientToCustomer";
import { useQuery } from "urql";

const ClientsByDomainQuery = graphql(`
  query GetClientsByDomain($domain: String!) {
    clientsByDomain(domain: $domain) {
      ...ClientForDetailsWithRecommendedObservation
    }
  }
`);

interface FilterOptions {
  domain: string;
}

export function useCustomersByDomain({ domain }: FilterOptions): DataAccessResult<Customer> {
  const [result] = useQuery({
    query: ClientsByDomainQuery,
    variables: { domain },
    pause: !domain,
    requestPolicy: "cache-first",
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = !data && isFetching;

  const customers = useMemo(() => {
    if (!data || !data.clientsByDomain) {
      return undefined;
    }

    return data.clientsByDomain.map(mapClientToCustomer);
  }, [data]);

  return {
    data: customers,
    isFetching,
    isPending,
    error,
  };
}
